export default "__VITE_ASSET__cd2ffacd__"